var _path, _path2, _path3, _path4, _path5, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValeTransporte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 123,
    viewBox: "0 0 145 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.598 97.133L0 97.133L0 68.9321C0 56.8306 9.84058 47.002 21.9301 47.002L122.656 47.002C134.746 47.002 144.586 56.8425 144.586 68.9321V97.133H144.598ZM10.7092 86.4238L133.889 86.4238V68.9321C133.889 62.7445 128.856 57.7112 122.668 57.7112L21.9301 57.7112C15.7426 57.7112 10.7092 62.7445 10.7092 68.9321L10.7092 86.4238Z",
    fill: "#F9A003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4109 72.0615C37.4109 67.4744 33.6923 63.7559 29.1053 63.7559C24.5182 63.7559 20.7997 67.4744 20.7997 72.0615C20.7997 76.6485 24.5182 80.367 29.1053 80.367C33.6923 80.367 37.4109 76.6485 37.4109 72.0615Z",
    fill: "#F9A003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.144 72.0615C123.144 67.4744 119.426 63.7559 114.839 63.7559C110.251 63.7559 106.533 67.4744 106.533 72.0615C106.533 76.6485 110.251 80.367 114.839 80.367C119.426 80.367 123.144 76.6485 123.144 72.0615Z",
    fill: "#F9A003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 55.6165L8.2937 53.5937L15.4094 16.6588C17.2656 7.05618 25.6902 0.095193 35.4594 0.0832939L108.413 0L108.437 0C118.218 0 126.654 6.96099 128.499 16.5636L135.614 53.4747L125.096 55.4975L117.98 18.5864C117.099 14.0172 113.089 10.6973 108.437 10.6973L35.4832 10.7806C30.8307 10.7806 26.8206 14.1005 25.9401 18.6697L18.8244 55.6046L18.8125 55.6165Z",
    fill: "#F9A003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.839 57.7115L74.786 57.7115L73.5961 53.9871C72.906 51.8214 72.5609 49.5606 72.5609 47.2522C72.5609 34.9842 82.5443 25.0127 94.8123 25.0127C107.08 25.0127 117.064 34.9842 117.064 47.2522C117.064 49.5606 116.719 51.8214 116.028 53.9871L114.839 57.7115ZM83.2701 47.0023L106.354 47.0023C106.224 40.7552 101.095 35.7219 94.8123 35.7219C88.5295 35.7219 83.401 40.7552 83.2701 47.0023Z",
    fill: "#F9A003"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5136 122.24C9.65019 122.24 0 112.59 0 100.726L0 86.5542L43.0273 86.5542L43.0273 100.726C43.0273 112.59 33.3771 122.24 21.5136 122.24ZM10.7092 97.2634L10.7092 100.726C10.7092 106.688 15.5522 111.53 21.5136 111.53C27.4751 111.53 32.318 106.688 32.318 100.726V97.2634L10.7092 97.2634Z",
    fill: "#F9A003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.132 122.24C111.269 122.24 101.619 112.59 101.619 100.726L101.619 86.5542L144.646 86.5542V100.726C144.646 112.59 134.996 122.24 123.132 122.24ZM112.328 97.2634L112.328 100.726C112.328 106.688 117.171 111.53 123.132 111.53C129.094 111.53 133.937 106.688 133.937 100.726V97.2634L112.328 97.2634Z",
    fill: "#F9A003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.658,
    height: 122.24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValeTransporte);
export default __webpack_public_path__ + "static/media/vale-transporte.443128e16b7a0f2c87f1bb0517f59557.svg";
export { ForwardRef as ReactComponent };